import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  GetEvolutionOptionsInput,
  GetEvolutionOptionsOutput,
  EvolvePokemonInput,
  EvolvePokemonOutput,
  WebAppRoutes,
} from "types/web-app";

/**
 * Get available evolution options for a Pokemon
 */
export const getEvolutionOptions = async (
  accessToken: string,
  input: GetEvolutionOptionsInput
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.GET_EVOLUTION_OPTIONS,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      }
    );

    return (await response.json()) as ServiceResponse<GetEvolutionOptionsOutput>;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Evolve a Pokemon to a target species
 */
export const evolvePokemon = async (
  accessToken: string,
  input: EvolvePokemonInput
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.EVOLVE_POKEMON,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      }
    );

    return (await response.json()) as ServiceResponse<EvolvePokemonOutput>;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

